module.exports = __webpack_public_path__ + "static/media/background-control-payment@2x.12010953.jpg";